<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <slot></slot>
      </div>
    </template>

    <div class="vb-dialog">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>{{ $t('routes.recycleBin.setRetentionTime') }}</span>
          <v-btn icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-form ref="form" v-on:submit.prevent="saveRetentionPeriod()">
          <v-card-text class="pt-5">
            <v-text-field
              v-model="currentRetentionPeriod"
              :rules="currentRetentionPeriodRules"
              :label="$t('routes.recycleBin.retentionPeriodDays')"
              required
              block
              variant="solo-filled"
              flat
            />

            <div v-if="errorMessage" class="bg-error">
              {{ errorMessage }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn type="submit" :disabled="inProgress || !isRetentionPeriodValid" class="bg-primary">{{ $t('common.save') }}</v-btn>
            <v-btn variant="text" @click="closeDialog()" class="btnCancel">{{ $t('common.cancel') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useTenantStore } from '@/stores/TenantStore.js'

export default {
  emits: ['update:modelValue'],
  name: "RecycleBinSetRetentionPeriodDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    retentionPeriod: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      errorMessage: '',
      inProgress: false,
      isRetentionPeriodValid: true,

      currentRetentionPeriod: this.$props.retentionPeriod,
      currentRetentionPeriodRules: [
        (val) => {
          const parsedValue = Number(val);
          return !Number.isSafeInteger(parsedValue) || parsedValue <= 0 || parsedValue > 180
            ? this.$t('routes.recycleBin.invalidRetentionPeriod')
            : true;
        }
      ],
    };
  },
  watch: {
    showDialog: function() {
      this.errorMessage = '';
      this.inProgress = false;
      this.currentRetentionPeriod = this.retentionPeriod;
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    saveRetentionPeriod: async function () {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.inProgress = true;

      const authStore = useAuthStore();
      const rootNodeId = authStore.rootNodeId;
      const retentionPeriod = Number(this.currentRetentionPeriod);

      try {
        const tenantStore = useTenantStore();
        await tenantStore.updateTenantSettings({
          accessPointId: rootNodeId,
          settings: {
            recycle_bin_retention_period: retentionPeriod,
          },
        });

        this.closeDialog();
      } catch (error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          this.errorMessage = error.response.data.error.message;
        } else {
          this.errorMessage = this.$t('common.generalError');
        }
      } finally {
        this.inProgress = false;
      }
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
}
</script>

<style scoped>

</style>
